/**
 * 资源权限模块接口列表
 */
 import $http from '../utils/http'; // 导入http中创建的axios实例

 const resroucePermis = {
    // 查询资源菜单
    queryResourceTypeBox(id,params){
        let param = new URLSearchParams();
        param.append(id, params);
        return $http.post(`${global.API_URL}/sme/group/queryResourceTypeBox`,param)
    },
    // 查询二级资源菜单
    querySubResourceTypeBox(params){
        return $http.post(`${global.API_URL}/sme/group/querySubResourceTypeBox?accountType=${params.accountType}&path=${params.path}`)
    },

    // 对象存储- AWS-存储桶
    // 分页查询
    queryBucketsByGroupId(params){
        return $http.post(`${global.API_URL}/sme/bucket/queryBucketsByGroupId`,params)
    },
    // 查询资源
    queryBucketGroupByAccountId(params){
        return $http.post(`${global.API_URL}/sme/bucket/queryBucketGroupByAccountId`,params)
    },
    // 添加资源
    createObjStorage(params){
        return $http.post(`${global.API_URL}/sme/groupBucketRelation/create`,params)
    },
    // 删除
    deleteByGroupIdAndBucketId(params){
        return $http.post(`${global.API_URL}/sme/groupBucketRelation/deleteByGroupIdAndBucketId`,params)
    },

    // 日志服务 - aliyun- sls
    // 分页查询
    queryLogsByGroupId(params){
        return $http.post(`${global.API_URL}/sme/log/queryLogsByGroupId`,params)
    },
    // 查询资源
    queryLogByAccountId(params){
        return $http.post(`${global.API_URL}/sme/log/queryLogByAccountId`,params)
    },
    // 添加资源
    createLogService(params){
        return $http.post(`${global.API_URL}/sme/groupLogRelation/create`,params)
    },
    // 删除
    deleteByGroupIdAndLogId(params){
        return $http.post(`${global.API_URL}/sme/groupLogRelation/deleteByGroupIdAndLogId`,params)
    },

    // 负载均衡
    // 分页查询
    queryLoadBalancersByGroupId(params){
        return $http.post(`${global.API_URL}/sme/loadBalancer/queryLoadBalancersByGroupId`,params)
    },
    // 查询资源
    queryLoadBalancerByAccountId(params){
        return $http.post(`${global.API_URL}/sme/loadBalancer/queryLoadBalancerByAccountId`,params)
    },
    // 添加资源
    createLoadBalancerRelation(params){
        return $http.post(`${global.API_URL}/sme/groupLoadBalancerRelation/create`,params)
    },
    // 删除
    deleteByGroupIdAndLoadBalancerId(params){
        return $http.post(`${global.API_URL}/sme/groupLoadBalancerRelation/deleteByGroupIdAndLoadBalancerId`,params)
    },


    // Nat网关
    // 分页查询
    queryNatGatewayByGroupId(params){
        return $http.post(`${global.API_URL}/sme/resourceNatgateway/queryNatGatewayByGroupId`,params)
    },
    // 查询资源
    queryNatGatewayByAccountId(params){
        return $http.post(`${global.API_URL}/sme/resourceNatgateway/queryNatGatewayByAccountId`,params)
    },
    // 添加资源
    createNatGateway(params){
        return $http.post(`${global.API_URL}/sme/groupNatGatewayRelation/create`,params)
    },
    // 删除
    deleteByGroupIdAndNatGatewayId(params){
        return $http.post(`${global.API_URL}/sme/groupNatGatewayRelation/deleteByGroupIdAndNatGatewayId`,params)
    },


    // 数据仓库
    // 分页查询
    queryRedshiftsByGroupId(params){
        return $http.post(`${global.API_URL}/sme/redshift/queryRedshiftsByGroupId`,params)
    },
    // 查询资源
    queryRedshiftByAccountId(params){
        return $http.post(`${global.API_URL}/sme/redshift/queryRedshiftByAccountId`,params)
    },
    // 添加资源
    createRedshiftRelation(params){
        return $http.post(`${global.API_URL}/sme/groupRedshiftRelation/create`,params)
    },
    // 删除
    deleteByGroupIdAndClusterId(params){
        return $http.post(`${global.API_URL}/sme/groupRedshiftRelation/deleteByGroupIdAndClusterId`,params)
    },


    // elasticsearch
    // 分页查询
    queryEsByGroupId(params){
        return $http.post(`${global.API_URL}/sme/elasticsearch/queryEsByGroupId`,params)
    },
    // 查询资源
    queryEsByAccountId(params){
        return $http.post(`${global.API_URL}/sme/elasticsearch/queryEsByAccountId`,params)
    },
    // 添加资源
    createEsRelation(params){
        return $http.post(`${global.API_URL}/sme/groupEsRelation/create`,params)
    },
    // 删除
    deleteByGroupIdAndEsId(params){
        return $http.post(`${global.API_URL}/sme/groupEsRelation/deleteByGroupIdAndEsId`,params)
    },


    // 备份计划
    // 分页查询
    queryBackupPlanByGroupId(params){
        return $http.post(`${global.API_URL}/sme/resourceAwsBackupPlan/queryBackupPlanByGroupId`,params)
    },
    // 查询资源
    queryBackupPlanByAccountId(params){
        return $http.post(`${global.API_URL}/sme/resourceAwsBackupPlan/queryBackupPlanByAccountId`,params)
    },
    // 添加资源
    createBackupPlanRelation(params){
        return $http.post(`${global.API_URL}/sme/groupBackupPlanRelation/create`,params)
    },
    // 删除
    deleteByGroupIdAndbackupPlanId(params){
        return $http.post(`${global.API_URL}/sme/groupBackupPlanRelation/deleteByGroupIdAndbackupPlanId`,params)
    },


    // web应用防火墙
    // 分页查询
    queryWafsByGroupId(params){
        return $http.post(`${global.API_URL}/sme/groupWafRelation/queryWafsByGroupId`,params)
    },
    // 查询资源
    queryfirewallAlicenByAccountId(params){
        return $http.post(`${global.API_URL}/sme/groupWafRelation/queryCloudWafsByAccountId`,params)
    },
    // 添加资源
    createWafRelation(params){
        return $http.post(`${global.API_URL}/sme/groupWafRelation/create`,params)
    },
    // 删除
    deletefirewallByGroupIdAndInstanceId(params){
        return $http.post(`${global.API_URL}/sme/groupWafRelation/deleteByGroupIdAndInstanceId`,params)
    },

    // CEN(阿里云云企业网)
    // 添加资源
    createAliCenRelation(params){
        return $http.post(`${global.API_URL}/sme/groupAliCenRelation/create`,params)
    },
    // 分页查询
    queryAlicensByGroupId(params){
        return $http.post(`${global.API_URL}/sme/groupAliCenRelation/queryAlicensByGroupId`,params)
    },
    // 查询资源
    queryCENAlicenByAccountId(params){
        return $http.post(`${global.API_URL}/sme/groupAliCenRelation/queryAlicenByAccountId`,params)
    },
    // 删除
    deleteCENByGroupIdAndInstanceId(params){
        return $http.post(`${global.API_URL}/sme/groupAliCenRelation/deleteByGroupIdAndInstanceId`,params)
    },


    // 弹性IP
    // 添加资源
    createElasticIP(params){
        return $http.post(`${global.API_URL}/sme/groupEipRelation/create`,params)
    },
    // 分页查询
    queryEipsByGroupId(params){
        return $http.post(`${global.API_URL}/sme/groupEipRelation/queryEipsByGroupId`,params)
    },
    // 查询资源
    queryEipsByAccountId(params){
        return $http.post(`${global.API_URL}/sme/groupEipRelation/queryEipsByAccountId`,params)
    },
    // 删除
    deleteElasticIPByGroupIdAndInstanceId(params){
        return $http.post(`${global.API_URL}/sme/groupEipRelation/deleteByGroupIdAndInstanceId`,params)
    },


    // Autoscalings
    // 添加资源
    createAutoscalings(params){
        return $http.post(`${global.API_URL}/sme/groupAutoScalingRelation/create`,params)
    },
    // 分页查询
    queryAutoscalingsByGroupId(params){
        return $http.post(`${global.API_URL}/sme/groupAutoScalingRelation/queryAutoscalingsByGroupId`,params)
    },
    // 查询资源
    queryAutoscalingsByAccountId(params){
        return $http.post(`${global.API_URL}/sme/groupAutoScalingRelation/queryAutoscalingsByAccountId`,params)
    },
    // 删除
    deleteAutoscalingsByGroupIdAndInstanceId(params){
        return $http.post(`${global.API_URL}/sme/groupAutoScalingRelation/deleteByGroupIdAndInstanceId`,params)
    },
   // 资源组列表
   queryResourceGroupList(params) {
      return $http.post(`${global.API_URL}/sme/resourceGroup/page`,params)
   },
   // 资源组名称重复验证
   duplicateCheckResourceGroup(params) {
     return $http.post(`${global.API_URL}/sme/resourceGroup/duplicateCheck`,params)
   },
   // TagKey列表
   queryTagKey(params) {
     return $http.post(`${global.API_URL}/sme/resourceTagRelationship/queryTagKey`,params)
   },
   // TagValue列表
   queryTagValue(params) {
     return $http.post(`${global.API_URL}/sme/resourceTagRelationship/queryTagValue`,params)
   },
   queryResourceAndDefaultMetric(params) {
      return $http.post(`${global.API_URL}/sme/resourceTagRelationship/queryResourceAndDefaultMetricByTag`,params)
   },
   // 联系人列表
   queryContactList(params) {
     return $http.post(`${global.API_URL}/sme/contact/queryContactsByAccountId`,params)
   },
   queryContactGroupList(id) {
     return $http.post(`${global.API_URL}/sme/contactGroup/listContactGroupsByAccountId?accountId=${id}`)
   },
   // 操作日志
   queryOperationLogList(id) {
     return $http.post(`${global.API_URL}/sme/resourceGroupOperationLog/queryResourceGroupOperationLog?id=${id}`)
   },
   // 资源类型列表
   queryResourceTypeList() {
     return $http.post(`${global.API_URL}/sme/resourceGroup/resourceTypeBox`)
   },
   // 资源组详情
   getResourceGroupInfo(id) {
     return $http.post(`${global.API_URL}/sme/resourceGroup/queryResourceGroupDetail?id=${id}`)
   },
   // 新增资源组
   addResourceGroup(params) {
     return $http.post(`${global.API_URL}/sme/resourceGroup/addResourceGroup`, params)
   },
   // 编辑资源组
   editResourceGroup(params) {
     return $http.post(`${global.API_URL}/sme/resourceGroup/updateResourceGroup`, params)
   },
   // 删除资源组
   deleteResourceGroup(params) {
     return $http.post(`${global.API_URL}/sme/resourceGroup/delete`, params)
   },
   queryMonitoritemVariablesByResourceType(params) {
     return $http.post(`${global.API_URL}/sme/resourceGroup/queryMonitoritemVariablesByResourceType`, params)
   },
   // 资源同步记录
   queryResourceSyncLog(params) {
     return $http.post(`${global.API_URL}/sme/syncResourceLog/page`, params)
   }
 }
 export default resroucePermis;



// WEBPACK FOOTER //
// ./src/api/resourcePermis.js